import React, { PureComponent } from 'react';
import { CopyOutlined } from '@ant-design/icons';
import { Collapse } from 'antd';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { nl2br } from '../../../utils/utils';

const {Panel} = Collapse;

class AwsPolicy extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      copiedPolicy: false,
    };
  }
  callback(key) {}

  copy(value) {
    this.setState({ copiedPolicy: true });
  }
  render() {
    const Policy = `{
      "Version": "2012-10-17",
      "Statement": [
          {
              "Sid": "VisualEditor0",
              "Effect": "Allow",
              "Action": [
                  "config:Get*",
                  "iam:List*",
                  "mediaconnect:Describe*",
                  "greengrass:List*",
                  "translate:List*",
                  "cloudtrail:GetTrailStatus",
                  "cloudfront:Get*",
                  "chime:List*",
                  "firehose:Describe*",
                  "codedeploy:List*",
                  "guardduty:List*",
                  "cloudwatch:Describe*",
                  "batch:DescribeComputeEnvironments",
                  "config:Describe*",
                  "serverlessrepo:GetApplicationPolicy",
                  "iam:SimulateCustomPolicy",
                  "ses:GetIdentityDkimAttributes",
                  "route53:Get*",
                  "rds:DownloadDBLogFilePortion",
                  "dynamodb:DescribeContinuousBackups",
                  "s3:GetBucket*",
                  "opsworks-cm:DescribeServers",
                  "codebuild:ListProjects",
                  "kinesisanalytics:ListApplications",
                  "acm:List*",
                  "serverlessrepo:List*",
                  "cloudtrail:LookupEvents",
                  "cloudsearch:DescribeServiceAccessPolicies",
                  "dms:Describe*",
                  "lambda:List*",
                  "kms:Describe*",
                  "s3:GetPublicAccessBlock",
                  "codecommit:GetObjectIdentifier",
                  "cloudhsm:ListLunaClients",
                  "workspaces:Describe*",
                  "ses:ListVerifiedEmailAddresses",
                  "glacier:ListVaults",
                  "logs:ListTagsLogGroup",
                  "s3:GetLifecycleConfiguration",
                  "tag:GetResources",
                  "acm:Describe*",
                  "dynamodb:ListTables",
                  "cognito-identity:ListIdentityPools",
                  "route53domains:GetDomainDetail",
                  "gamelift:ListFleets",
                  "license-manager:List*",
                  "iam:Get*",
                  "mediaconnect:List*",
                  "transfer:Describe*",
                  "ses:ListIdentities",
                  "s3:PutBucketVersioning",
                  "dms:ListTagsForResource",
                  "sns:GetTopicAttributes",
                  "ec2:Describe*",
                  "es:ListDomainNames",
                  "codedeploy:Get*",
                  "rds:ListTagsForResource",
                  "dynamodb:ListGlobalTables",
                  "s3:ListAllMyBuckets",
                  "s3:PutBucketWebsite",
                  "dynamodb:DescribeGlobalTable",
                  "codecommit:GetBranch",
                  "robomaker:List*",
                  "fsx:Describe*",
                  "kms:Get*",
                  "fsx:List*",
                  "cognito-sync:Describe*",
                  "dynamodb:DescribeTable",
                  "codepipeline:ListPipelines",
                  "cloudtrail:ListTags",
                  "route53:List*",
                  "cloudformation:ListStack*",
                  "rekognition:List*",
                  "trustedadvisor:Describe*",
                  "cloudhsm:ListHsms",
                  "iot:List*",
                  "ses:GetIdentityVerificationAttributes",
                  "organizations:Describe*",
                  "redshift:Describe*",
                  "batch:DescribeJobDefinitions",
                  "eks:DescribeCluster",
                  "organizations:List*",
                  "route53resolver:List*",
                  "shield:List*",
                  "s3:GetAccelerateConfiguration",
                  "cloudtrail:GetEventSelectors",
                  "datasync:Describe*",
                  "tag:GetTagKeys",
                  "s3:PutEncryptionConfiguration",
                  "securityhub:Get*",
                  "s3:GetEncryptionConfiguration",
                  "iot:Describe*",
                  "rekognition:Describe*",
                  "codestar:List*",
                  "shield:Describe*",
                  "ecr:DescribeRepositories",
                  "ecs:List*",
                  "sqs:ListQueues",
                  "application-autoscaling:Describe*",
                  "codestar:Describe*",
                  "datapipeline:GetPipelineDefinition",
                  "dynamodb:DescribeTimeToLive",
                  "kinesis:ListTagsForStream",
                  "ram:List*",
                  "dax:ListTags",
                  "waf:ListWebACLs",
                  "comprehend:Describe*",
                  "athena:List*",
                  "kinesis:ListStreams",
                  "datapipeline:EvaluateExpression",
                  "elasticmapreduce:ListInstances",
                  "rds:Describe*",
                  "s3:PutLifecycleConfiguration",
                  "ssm:ListDocuments",
                  "quicksight:List*",
                  "config:Deliver*",
                  "cloudfront:List*",
                  "waf-regional:ListWebACLs",
                  "quicksight:Describe*",
                  "sns:ListSubscriptionsByTopic",
                  "datapipeline:ListPipelines",
                  "s3:DeleteBucketPolicy",
                  "cloudtrail:DescribeTrails",
                  "s3:GetReplicationConfiguration",
                  "s3:PutObject",
                  "cloudformation:GetStackPolicy",
                  "globalaccelerator:Describe*",
                  "eks:ListClusters",
                  "iam:GenerateCredentialReport",
                  "s3:GetInventoryConfiguration",
                  "cloudtrail:StartLogging",
                  "route53domains:ListTagsForDomain",
                  "glacier:DescribeVault",
                  "sns:ListTopics",
                  "datapipeline:ValidatePipelineDefinition",
                  "datapipeline:DescribePipelines",
                  "route53domains:ListDomains",
                  "s3:PutBucketTagging",
                  "robomaker:Describe*",
                  "cloudsearch:DescribeDomains",
                  "datasync:List*",
                  "ecs:Describe*",
                  "datapipeline:QueryObjects",
                  "guardduty:Get*",
                  "codecommit:BatchGetRepositories",
                  "kinesis:DescribeStream",
                  "elasticache:Describe*",
                  "dynamodb:ListStreams",
                  "cloud9:ListEnvironments",
                  "directconnect:Describe*",
                  "globalaccelerator:List*",
                  "route53domains:ListOperations",
                  "cloudtrail:CreateTrail",
                  "cognito-sync:List*",
                  "states:ListStateMachines",
                  "kms:List*",
                  "glacier:GetVaultAccessPolicy",
                  "logs:Describe*",
                  "appsync:List*",
                  "clouddirectory:ListDirectories",
                  "firehose:List*",
                  "elasticmapreduce:Describe*",
                  "s3:GetObjectAcl",
                  "iam:SimulatePrincipalPolicy",
                  "codedeploy:Batch*",
                  "s3:GetObjectVersionAcl",
                  "events:ListRules",
                  "s3:PutBucketAcl",
                  "elasticloadbalancing:Describe*",
                  "gamelift:ListBuilds",
                  "cloud9:Describe*",
                  "es:Describe*",
                  "sdb:DomainMetadata",
                  "cloudhsm:ListHapgs",
                  "sqs:GetQueueAttributes",
                  "elasticbeanstalk:Describe*",
                  "cognito-idp:ListUserPools",
                  "route53domains:GetOperationDetail",
                  "dax:Describe*",
                  "events:DescribeEventBus",
                  "codecommit:GetRepository",
                  "cloudformation:GetTemplate",
                  "transfer:List*",
                  "s3:GetAnalyticsConfiguration",
                  "codecommit:List*",
                  "mediastore:GetContainerPolicy",
                  "lambda:GetAccountSettings",
                  "machinelearning:DescribeMLModels",
                  "elasticmapreduce:ListClusters",
                  "s3:GetMetricsConfiguration",
                  "elasticfilesystem:DescribeFileSystems",
                  "comprehend:List*",
                  "dynamodb:ListBackups",
                  "mediastore:ListContainers",
                  "datapipeline:DescribeObjects",
                  "sdb:ListDomains",
                  "cloudformation:DescribeStack*",
                  "securityhub:List*",
                  "ssm:Describe*",
                  "ds:DescribeDirectories",
                  "s3:PutBucketPolicy",
                  "lambda:GetPolicy",
                  "ecr:GetRepositoryPolicy",
                  "events:DescribeRule"
              ],
              "Resource": "*"
          },
          {
              "Sid": "VisualEditor1",
              "Effect": "Allow",
              "Action": "apigateway:GET",
              "Resource": [
                  "arn:aws:apigateway:*::/restapis",
                  "arn:aws:apigateway:*::/restapis/*/authorizers",
                  "arn:aws:apigateway:*::/restapis/*/authorizers/*",
                  "arn:aws:apigateway:*::/restapis/*/resources",
                  "arn:aws:apigateway:*::/restapis/*/resources/*",
                  "arn:aws:apigateway:*::/restapis/*/resources/*/methods/*",
                  "arn:aws:apigateway:*::/vpclinks"
              ]
          },
          {
              "Sid": "VisualEditor2",
              "Effect": "Allow",
              "Action": [
                  "apigateway:HEAD",
                  "apigateway:OPTIONS"
              ],
              "Resource": [
                  "arn:aws:apigateway:*::/restapis",
                  "arn:aws:apigateway:*::/restapis/*/authorizers",
                  "arn:aws:apigateway:*::/restapis/*/authorizers/*",
                  "arn:aws:apigateway:*::/restapis/*/resources",
                  "arn:aws:apigateway:*::/restapis/*/resources/*",
                  "arn:aws:apigateway:*::/restapis/*/resources/*/methods/*",
                  "arn:aws:apigateway:*::/vpclinks"
              ]
          },
          {
              "Sid": "VisualEditor3",
              "Effect": "Allow",
              "Action": [
                  "appmesh:List*",
                  "appmesh:Describe*"
              ],
              "Resource": "*"
          }
      ]
  }`;

    return (
      <div>
        {/* <div> AWS Policy :</div> */}
        {/* <div style={{ color: '#272727' }}>
          <div>
            <CopyToClipboard className={styles.policy} text={Policy}>
              <Icon type="copy" onClick={e => this.copy(e.target.value)} />
            </CopyToClipboard>
          </div>
          AWS Policy :
          {this.state.copied ? <span style={{ color: 'red', marginLeft: 20 }}>Copied.</span> : null}
        </div> */}
        {/* {this.state.copied ? <span style={{ color: 'red' }}>Copied.</span> : null}
          <div style={{ float: 'right' }}>
            <CopyToClipboard text={Policy}>
              <Icon
                className={styles.copyIcon}
                type="copy"
                onClick={e => this.copy(e.target.value)}
              />
            </CopyToClipboard>
          </div> */}

        <div>
          {this.state.copiedPolicy ? (
            <span style={{ color: 'green', float: 'right', marginTop: -24, marginRight: 13 }}>
              Copied.
            </span>
          ) : null}
          <div>
            <CopyToClipboard text={Policy}>
              <CopyOutlined
                title="Copy selected policy"
                style={{ float: 'right', marginTop: -22 }}
                onClick={e => this.copy(e.target.value)}
              />
            </CopyToClipboard>
          </div>
          <Collapse style={{ marginTop: 20 }}>
            <Panel header="View Full Protection Policy">
              <pre>
                <code dangerouslySetInnerHTML={{ __html: nl2br(Policy) }} />{' '}
              </pre>
              {/* <p>{text}</p> */}
            </Panel>
          </Collapse>
        </div>
        <div style={{ marginTop: 7, color: '#8F8F8F' }}>
          Attach the following Full Protection Policy
        </div>
      </div>
    );
  }
}

export default AwsPolicy;
